module.exports = __webpack_public_path__ + "static/img/20.c70e52d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/website/20.png
// module id = JtOj
// module chunks = 1